import React from 'react';

import { Menu } from 'semantic-ui-react';

const ProfileMenu = (props) => {
    const {activeItem, handleMenuClick} = props; // 1-Bio+Dependents(View + Edit), 2-My Plan, 3-Wallet, 4-Change Password
    return (
        <Menu attached='top' tabular>
          <Menu.Item name='Item Listing' active={activeItem === 1} onClick={handleMenuClick} />
          <Menu.Item name='Purchased' active={activeItem === 2} onClick={handleMenuClick} />
        </Menu>
    );
}

export default ProfileMenu;

/*
<Menu.Item name='Wallet' active={activeItem === 3} onClick={handleMenuClick} />
*/